import classNames from 'classnames'
import {useSelector} from 'react-redux'

const Box = ({title, value, className}) => {
    const sidebarIsActive = useSelector(state => state.sidebar.sidebarIsActive)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <div className={classNames('box-container', {
            active: sidebarIsActive,
            dark: isDarkMode
        })}>
            <div className={classNames('box', {
                dark: isDarkMode
            })}>
                <span className={className}>{value}</span>
                <span>{title}</span>
            </div>
        </div>
    )
}

export default Box
